import { Link } from 'react-router-dom';
import { siteStats } from '@/mocks/homeData';
import AnimatedSection from '@/components/base/AnimatedSection';

export default function AboutBrandSection() {
  return (
    <section className="relative py-24 md:py-32 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <AnimatedSection animation="fade-up">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24">
          {/* Left - Label */}
          <div className="lg:w-auto flex-shrink-0">
            <span className="text-xs font-medium text-foreground-700 tracking-widest uppercase">
              / about
            </span>
          </div>

          {/* Center/Right - Main content */}
          <div className="flex-1 max-w-3xl">
            <p className="text-xl md:text-2xl text-foreground-400 font-light leading-relaxed mb-12">
              黑料视频成立于 2024 年，致力于打造全网最真实、最及时的娱乐八卦聚合平台。我们相信，真相不应该被资本和公关掩盖。每一段视频、每一条爆料，都经过了严格的来源核实，确保瓜友们吃到的每一口瓜都是真的。
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6">
              {/* Avatars group */}
              <div className="flex -space-x-2">
                <div className="w-11 h-11 rounded-full border-2 border-background-100 overflow-hidden grayscale">
                  <img
                    src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20anonymous%20portrait%20in%20shadow%2C%20noir%20style%20headshot%2C%20low%20key%20lighting%2C%20professional%20look%2C%20dark%20monochrome%20tone&width=80&height=80&seq=brand-avatar-01&orientation=squarish"
                    alt="团队成员"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-11 h-11 rounded-full border-2 border-background-100 overflow-hidden grayscale">
                  <img
                    src="https://readdy.ai/api/search-image?query=Dark%20anonymous%20portrait%20silhouette%20with%20side%20profile%2C%20noir%20headshot%2C%20low%20key%20lighting%2C%20mysterious%20professional%2C%20dark%20monochrome&width=80&height=80&seq=brand-avatar-02&orientation=squarish"
                    alt="团队成员"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-11 h-11 rounded-full border-2 border-background-100 overflow-hidden grayscale">
                  <img
                    src="https://readdy.ai/api/search-image?query=Dark%20portrait%20of%20anonymous%20figure%20facing%20forward%2C%20noir%20photography%2C%20low%20key%20lighting%2C%20mysterious%20professional%20look%2C%20monochrome%20tone&width=80&height=80&seq=brand-avatar-03&orientation=squarish"
                    alt="团队成员"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-11 h-11 rounded-full border-2 border-background-100 overflow-hidden grayscale">
                  <img
                    src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20silhouette%20portrait%2C%20looking%20slightly%20up%2C%20noir%20style%2C%20low%20key%20headshot%2C%20professional%20anonymous%2C%20dark%20monochrome&width=80&height=80&seq=brand-avatar-04&orientation=squarish"
                    alt="团队成员"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div>
                <span className="text-sm text-foreground-400">
                  已累计服务 <strong className="text-primary-400">{siteStats.onlineUsers}</strong> 位吃瓜群众
                </span>
                <Link
                  to="/about"
                  className="block mt-1 text-sm font-semibold text-primary-400 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  了解更多关于我们 →
                </Link>
              </div>
            </div>
          </div>
        </div>
        </AnimatedSection>
      </div>
    </section>
  );
}